import axios from 'axios';
import { baseUrl, httpUrl } from '@/utils/constant'
import { setToken, getToken, removeToken } from '@/utils/auth'
import { Dialog, Toast } from 'vant';

// token错误的code
const invalidTokenCodes = [10001, 10002];
function reLogin() {
  removeToken();
  window.location.replace(`${httpUrl}init-page?redirect=${location.hash.slice(1).split('?')[0]}`);
}

function getInitConfig () {
  const config = {
    baseURL: baseUrl,
    // baseURL: 'https://tactivity.quanyou.com.cn/common_gw/',
    headers: {
      Authorization: getToken(),
      'Content-Type': 'application/json;charset=utf-8'
    }
  };
  return config;
}

const axiosInstance = axios.create(getInitConfig());

axiosInstance.interceptors.request.use(
  config => {
    config.headers.Authorization = getToken();
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

axiosInstance.interceptors.response.use(
  response => {
    const accessToken = response.headers['access_token']
    if (accessToken) {
      setToken(accessToken);
    }

    const { data } = response;
    // 未返回data属性，或code不是 200
    if (!data || +data.code !== 200) {
      data.message = data && !data.data && !data.message ? '异常数据' : data.message;
      Dialog.alert({
        message: data.message
      });
      return Promise.reject(data);
    }

    return data;
  },
  error => {
    let errorInfo = error.response
    let accessToken = '';
    let code = '';

    if (errorInfo) {
      accessToken = errorInfo.headers['access_token']
      code = errorInfo.data && errorInfo.data.code;
    }

    // 重新登录
    if (process.env.BUILD_ENV !== 'dev' && invalidTokenCodes.includes(+code)) {
      // TODO
      // reLogin();
      return;
    }

    // 错误响应有token时，更新token
    if (accessToken) {
      setToken(accessToken);
    }

    if (!errorInfo) {
      const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error))
      errorInfo = {
        statusText,
        status,
        request: { responseURL: config.url }
      }
    }

    // 全局错误通知
    Dialog.alert({
      message: !errorInfo.data.message ? error.message : errorInfo.data.message
    });
    return Promise.reject(error)
  }
);

export default axiosInstance;